/**
 * Dicionário de Mapeamento de Variáveis WATI vs. Banco de Dados SQL (SCORPIO ERP)
 * Grupo Emops - Ticket 287
 */

export const WATI_SQL_DICTIONARY = Object.freeze({
  nome: {
    nome: "nome",
    label: "Nome do Cliente",
    tabelaOrigem: "clientes",
    colunaOrigem: "nome_fantasia",
    descricaoEnvio: "Nome fantasia cadastrado do cliente da OS/Contrato",
    gravacaoWebhook: "Associado via waId/telefone aos contatos do cliente",
    modulo: "geral",
    suportado: true
  },
  cliente_nome: {
    nome: "cliente_nome",
    label: "Nome do Cliente",
    tabelaOrigem: "clientes",
    colunaOrigem: "nome_fantasia",
    descricaoEnvio: "Nome fantasia do cliente da OS",
    gravacaoWebhook: "Identificação do cliente no log",
    modulo: "geral",
    suportado: true
  },
  servico: {
    nome: "servico",
    label: "Nome do Serviço",
    tabelaOrigem: "controles",
    colunaOrigem: "nome",
    descricaoEnvio: "Nome do serviço/controle contratado (ex: Controle de Pragas)",
    gravacaoWebhook: "Informativo no histórico de confirmação",
    modulo: "confirmacao",
    suportado: true
  },
  tipo_servico: {
    nome: "tipo_servico",
    label: "Tipo de Serviço",
    tabelaOrigem: "os_tipos",
    colunaOrigem: "nome",
    descricaoEnvio: "Tipo da execução (ex: Inicial, Manutenção, Complementar)",
    gravacaoWebhook: "Informativo no histórico de confirmação",
    modulo: "confirmacao",
    suportado: true
  },
  os_cliente: {
    nome: "os_cliente",
    label: "Número da OS",
    tabelaOrigem: "os",
    colunaOrigem: "id",
    descricaoEnvio: "Identificador numérico exclusivo da Ordem de Serviço",
    gravacaoWebhook: "Gravado em os_confirmacao_whatsapp.id_os e chave de confirmação na tabela os",
    modulo: "confirmacao",
    suportado: true
  },
  os: {
    nome: "os",
    label: "Número da OS",
    tabelaOrigem: "os",
    colunaOrigem: "id",
    descricaoEnvio: "Identificador numérico exclusivo da Ordem de Serviço",
    gravacaoWebhook: "Gravado em os_confirmacao_whatsapp.id_os",
    modulo: "confirmacao",
    suportado: true
  },
  id_os: {
    nome: "id_os",
    label: "Número da OS",
    tabelaOrigem: "os",
    colunaOrigem: "id",
    descricaoEnvio: "Identificador numérico da OS",
    gravacaoWebhook: "Gravado em os_confirmacao_whatsapp.id_os",
    modulo: "confirmacao",
    suportado: true
  },
  local_servico: {
    nome: "local_servico",
    label: "Local do Serviço",
    tabelaOrigem: "clientes",
    colunaOrigem: "nome_fantasia",
    descricaoEnvio: "Nome da unidade ou filial onde o serviço será executado",
    gravacaoWebhook: "Informativo",
    modulo: "confirmacao",
    suportado: true
  },
  local: {
    nome: "local",
    label: "Endereço da Execução",
    tabelaOrigem: "enderecos",
    colunaOrigem: "logradouro, numero, bairro",
    descricaoEnvio: "Endereço completo da unidade de atendimento da OS",
    gravacaoWebhook: "Informativo no disparo",
    modulo: "confirmacao",
    suportado: true
  },
  data: {
    nome: "data",
    label: "Data Agendada",
    tabelaOrigem: "os",
    colunaOrigem: "data_competencia",
    descricaoEnvio: "Data agendada para a visita técnica da OS",
    gravacaoWebhook: "Ao confirmar, atualiza os.data_execucao = os.data_competencia",
    modulo: "confirmacao",
    suportado: true
  },
  hora: {
    nome: "hora",
    label: "Horário Agendado",
    tabelaOrigem: "os / turnos",
    colunaOrigem: "hora_marcada / turnos.nome",
    descricaoEnvio: "Horário fixo ou turno programado para atendimento",
    gravacaoWebhook: "Ao reagendar, atualiza os.hora_marcada ou os.id_turno",
    modulo: "confirmacao",
    suportado: true
  },
  valor: {
    nome: "valor",
    label: "Valor da Cobrança",
    tabelaOrigem: "contas_receber",
    colunaOrigem: "valor",
    descricaoEnvio: "Valor em reais (R$) do boleto ou título em aberto",
    gravacaoWebhook: "Informativo no histórico de cobrança",
    modulo: "cobranca",
    suportado: true
  },
  vencimento: {
    nome: "vencimento",
    label: "Data de Vencimento",
    tabelaOrigem: "contas_receber",
    colunaOrigem: "data_vencimento",
    descricaoEnvio: "Data limite de vencimento da fatura/boleto",
    gravacaoWebhook: "Informativo no histórico de cobrança",
    modulo: "cobranca",
    suportado: true
  },
  link_boleto: {
    nome: "link_boleto",
    label: "Link do Boleto / PDF",
    tabelaOrigem: "contas_receber",
    colunaOrigem: "link_boleto",
    descricaoEnvio: "URL pública para o cliente baixar o boleto/segunda via",
    gravacaoWebhook: "Informativo no disparo de cobrança",
    modulo: "cobranca",
    suportado: true
  },
  linkpdf: {
    nome: "linkpdf",
    label: "Link do Documento / Nota",
    tabelaOrigem: "notas / boletos",
    colunaOrigem: "link_pdf",
    descricaoEnvio: "Link direto para o PDF da nota fiscal ou fatura",
    gravacaoWebhook: "Informativo no disparo",
    modulo: "cobranca",
    suportado: true
  }
});

/**
 * Extrai a lista de variáveis de um objeto de template WATI
 * @param {Object} template
 * @param {string} modulo
 * @returns {Array<Object>}
 */
export function extrairVariaveisTemplate(template, modulo) {
  if (!template) return [];

  const variaveisMapeadas = [];
  const nomesEncontrados = new Set();

  // 1. Extrair de customParams se existir
  if (template.customParams && Array.isArray(template.customParams)) {
    template.customParams.forEach((param, index) => {
      const pName = (param.paramName || "").trim();
      if (pName && !nomesEncontrados.has(pName.toLowerCase())) {
        nomesEncontrados.add(pName.toLowerCase());
        const info = obterInfoMapeamento(pName, modulo);
        variaveisMapeadas.push({
          posicao: index + 1,
          nomeVariavel: pName,
          exemploWati: param.paramValue || "(não informado)",
          label: info.label,
          tabelaOrigem: info.tabelaOrigem,
          colunaOrigem: info.colunaOrigem,
          descricaoEnvio: info.descricaoEnvio,
          gravacaoWebhook: info.gravacaoWebhook,
          suportado: info.suportado
        });
      }
    });
  }

  // 2. Extrair do bodyOriginal ou body se houver {{nome}} ou {{1}}
  const textoParaBuscar = template.bodyOriginal || template.body || "";
  const matches = textoParaBuscar.match(/\{\{([a-zA-Z0-9_\-]+)\}\}/g);

  if (matches && Array.isArray(matches)) {
    matches.forEach(m => {
      const cleanVar = m.replace(/[{}]/g, "").trim();
      if (cleanVar && !nomesEncontrados.has(cleanVar.toLowerCase())) {
        nomesEncontrados.add(cleanVar.toLowerCase());
        const info = obterInfoMapeamento(cleanVar, modulo);
        variaveisMapeadas.push({
          posicao: variaveisMapeadas.length + 1,
          nomeVariavel: cleanVar,
          exemploWati: "-",
          label: info.label,
          tabelaOrigem: info.tabelaOrigem,
          colunaOrigem: info.colunaOrigem,
          descricaoEnvio: info.descricaoEnvio,
          gravacaoWebhook: info.gravacaoWebhook,
          suportado: info.suportado
        });
      }
    });
  }

  return variaveisMapeadas;
}

/**
 * Obtém informações de mapeamento SQL para determinado nome de parâmetro
 * @param {string} nomeParam
 * @param {string} modulo
 * @returns {Object}
 */
export function obterInfoMapeamento(nomeParam, modulo) {
  const norm = String(nomeParam || "").toLowerCase().trim();

  if (WATI_SQL_DICTIONARY[norm]) {
    return WATI_SQL_DICTIONARY[norm];
  }

  // Fallbacks inteligentes por nome aproximado
  if (norm.includes("os") || norm.includes("ordem")) {
    return WATI_SQL_DICTIONARY.os_cliente;
  }
  if (norm.includes("cliente") || norm.includes("nome")) {
    return WATI_SQL_DICTIONARY.nome;
  }
  if (norm.includes("servico") || norm.includes("serviço")) {
    return WATI_SQL_DICTIONARY.servico;
  }
  if (norm.includes("data") || norm.includes("dia")) {
    return WATI_SQL_DICTIONARY.data;
  }
  if (norm.includes("hora") || norm.includes("turno")) {
    return WATI_SQL_DICTIONARY.hora;
  }
  if (norm.includes("local") || norm.includes("endereco") || norm.includes("endereço")) {
    return WATI_SQL_DICTIONARY.local;
  }
  if (norm.includes("valor") || norm.includes("preco") || norm.includes("preço")) {
    return WATI_SQL_DICTIONARY.valor;
  }
  if (norm.includes("vencimento")) {
    return WATI_SQL_DICTIONARY.vencimento;
  }
  if (norm.includes("boleto") || norm.includes("link") || norm.includes("pdf")) {
    return WATI_SQL_DICTIONARY.link_boleto;
  }

  return {
    nome: nomeParam,
    label: "Parâmetro Customizado",
    tabelaOrigem: "Personalizado / Sem mapeamento direto",
    colunaOrigem: "-",
    descricaoEnvio: "Variável adicional do template sem campo SQL pré-definido",
    gravacaoWebhook: "Não gravado automaticamente",
    modulo: modulo || "geral",
    suportado: false
  };
}

export default {
  WATI_SQL_DICTIONARY,
  extrairVariaveisTemplate,
  obterInfoMapeamento
};
